export default __webpack_public_path__ + "static/media/tnote3.12ffc79e.jpg";